function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as FileSystem from "expo-file-system/legacy";
import { useRef } from "react";
import { Platform } from "react-native";
import { Kind } from "@oui/lib/src/types";
import { Button } from "./Button";
import { SignatureView as SignaturePad } from "./SignatureView";
import { View } from "./View";
import { DETOX_SIGNATURE } from "../constants";
var noopOnInput = function() {};
/**
 * Allows user to capture their signature by "drawing" on the screen for
 * submission as a `ChatInput`.
 *
 * In e2e testing mode, the drawing area is disabled and instead a pre-computed
 * signature is provided upon submission since the test harness cannot reliably
 * draw.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-61}
 */ export function ChatInputSignature(_param) {
    var _param_onInput = _param.onInput, onInput = _param_onInput === void 0 ? noopOnInput : _param_onInput, props = _object_without_properties(_param, [
        "onInput"
    ]);
    var pad = useRef(null);
    return /*#__PURE__*/ _jsxs(View, {
        style: {
            height: 200,
            flexGrow: 1,
            paddingVertical: 10,
            paddingHorizontal: 20
        },
        spacing: 4,
        testID: "ChatInputSignature",
        children: [
            /*#__PURE__*/ _jsxs(View, {
                style: {
                    flex: 1
                },
                children: [
                    global.e2e ? null : /*#__PURE__*/ _jsx(SignaturePad, {
                        ref: pad,
                        style: {
                            borderWidth: 1
                        }
                    }),
                    /*#__PURE__*/ _jsx(View, {
                        style: {
                            height: 1,
                            width: '90%',
                            left: '5%',
                            backgroundColor: 'black',
                            position: 'absolute',
                            bottom: 15
                        },
                        pointerEvents: "none"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Button, {
                "aria-label": "Clear signature",
                alignSelf: "center",
                icon: "close",
                variant: "text",
                onPress: function() {
                    if (pad.current) {
                        pad.current.clear();
                    }
                },
                style: {
                    position: 'absolute',
                    top: 12,
                    right: 25
                }
            }),
            /*#__PURE__*/ _jsx(Button, {
                alignSelf: "center",
                text: "Sign",
                variant: "contained",
                onPress: function() {
                    if (global.e2e) {
                        var uri = DETOX_SIGNATURE;
                        onInput({
                            kind: Kind.InputSignature,
                            props: {
                                uri: uri
                            }
                        });
                    } else if (pad.current) {
                        return pad.current.takeSnapshotAsync({
                            quality: 0.8,
                            format: 'png',
                            result: 'file'
                        }).then(function(result) {
                            if (Platform.OS === 'web') {
                                return new Promise(function(res) {
                                    var reader = new FileReader();
                                    reader.readAsDataURL(result.uri); // eslint-disable-line
                                    reader.onloadend = function() {
                                        // TODO this reqder.result returns base64 but the resulting image is blank for some reason :/
                                        var uri = reader.result || '';
                                        onInput({
                                            kind: Kind.InputSignature,
                                            props: {
                                                uri: uri
                                            }
                                        });
                                        res();
                                    };
                                });
                            } else {
                                return FileSystem.readAsStringAsync(result.uri, {
                                    encoding: FileSystem.EncodingType.Base64
                                }).then(function(base64) {
                                    var uri = "data:image/png;base64,".concat(base64);
                                    onInput({
                                        kind: Kind.InputSignature,
                                        props: {
                                            uri: uri
                                        }
                                    });
                                });
                            }
                        });
                    }
                    return;
                },
                testID: "ChatInputSignature_submit"
            })
        ]
    });
}
